export default __webpack_public_path__ + "static/media/stjosephvictoria.fb4c4893.jpg";